import useGetAllStrategicImperativeQuery from 'basics/graphql/queries/getAllStrategicImperatives';
import { StrategicImperative, StrategicImperativeFilter } from 'generated/maya.types';

const useStrategicImperativeOptions = (filters: StrategicImperativeFilter = {}) => {
  const { data: strategicImperatives, loading } = useGetAllStrategicImperativeQuery(
    undefined,
    filters,
  );
  const strategicImperativeOptions = strategicImperatives.map((element: StrategicImperative) => {
    return {
      id: element._id,
      label: element.title,
    };
  });

  return { options: strategicImperativeOptions, loading };
};

export default useStrategicImperativeOptions;
